export default function DatenLaden () {
    return (
        <div>
            <h3>&#8987; Daten werden geladen...</h3>
        </div>
    )
}